import React, { useState, useEffect } from 'react';
import { Calendar, Sparkles } from 'lucide-react';
import styles from './Calendar2026.module.css';

const Calendar2026 = () => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate floating particles
    const newParticles = Array.from({ length: 25 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
      duration: Math.random() * 15 + 20,
      delay: Math.random() * 8
    }));
    setParticles(newParticles);
  }, []);

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100
    });
  };

  const handleViewCalendar = () => {
    window.location.href = '/calendar-2026';
  };

  return (
    <div className={styles.container} onMouseMove={handleMouseMove}>
      <div className={styles.background}>
        <div 
          className={`${styles.gradientOrb} ${styles.orb1}`}
          style={{
            transform: `translate(${mousePos.x * 0.04}px, ${mousePos.y * 0.04}px)`
          }}
        />
        <div 
          className={`${styles.gradientOrb} ${styles.orb2}`}
          style={{
            transform: `translate(${-mousePos.x * 0.03}px, ${-mousePos.y * 0.03}px)`
          }}
        />
        <div 
          className={`${styles.gradientOrb} ${styles.orb3}`}
          style={{
            transform: `translate(${mousePos.x * 0.05}px, ${-mousePos.y * 0.05}px)`
          }}
        />
        
        <div className={styles.gridPattern}></div>
        
        {particles.map((particle) => (
          <div
            key={particle.id}
            className={styles.particle}
            style={{
              left: `${particle.x}%`,
              top: `${particle.y}%`,
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              animationDuration: `${particle.duration}s`,
              animationDelay: `${particle.delay}s`
            }}
          />
        ))}
      </div>

      <div className={styles.content}>
        
        <div className={styles.yearWrapper}>
          <span className={styles.year}>Happy New Year 2026</span>
        </div>
        
        <p className={styles.description}>
          Explore my beautifully designed custom calendar for 2026. 
          Each month features unique artwork and design elements crafted with passion.
        </p>
        
        <button onClick={handleViewCalendar} className={styles.viewBtn}>
          <span className={styles.btnBg}></span>
          <span className={styles.btnBorder}></span>
          <Calendar className={styles.btnIcon} />
          <span className={styles.btnText}>View Calendar</span>
          <div className={styles.btnShine}></div>
        </button>
      </div>

    </div>
  );
};

export default Calendar2026;